export const descriptionHeader = "Automate MAP-Migrated Tagging with CloudFlow";
export const description =
  "Ensure all of your eligible resources are correctly tagged automatically with DoiT CloudFlow. Without the\n" +
  "map-migrated tag, you will not receive the proper credit allocation from AWS.";
export const widgetCardTitle = "Automate MAP Tagging";
export const widgetCardSubheader = "[AWS MAP Lens] Leverage DoiT CloudFlow to tag eligible resources";
